/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ActionModel, ContainerModel, TableModel, TextModel } from '@typescript-kit/view';

export class TimeClockEmployeeComponentModel extends ContainerModel {

  get employeeName(): TextModel {
    return this.items.get('employeeName') as TextModel;
  }

  get companyName(): TextModel {
    return this.items.get('companyName') as TextModel;
  }

  get timeRecordContainer(): ContainerModel {
    return this.items.get('timeRecordContainer') as ContainerModel;
  }

  get timeRecordTable(): TableModel {
    return this.timeRecordContainer.items.get('timeRecordTable') as TableModel;
  }

  get actionMenu(): ContainerModel {
    return this.items.get('actionMenu') as ContainerModel;
  }

  get startAction(): ActionModel {
    return this.actionMenu.items.get('startAction') as ActionModel;
  }

  get stopAction(): ActionModel {
    return this.actionMenu.items.get('stopAction') as ActionModel;
  }

}
